/**
 * https://github.com/freeze-component/vue-popper
 * */
import Popper from 'popper.js'
Element.prototype.one = function(type, callback) {
  var handle = function() {
    callback = callback.call(this)
    this.removeEventListener(type, handle)
  }
  this.addEventListener(type, handle)
}
export default {
  props: {
    placement: {
      type: String,
      default: 'bottom'
    },
    boundariesPadding: {
      type: Number,
      default: 5
    },
    reference: Object,
    popper: Object,
    offset: {
      default: 0
    },
    value: {
      type: Boolean,
      default: false
    },
    transition: String,
    options: {
      type: Object,
      default () {
        return {
          gpuAcceleration: false,
          boundariesElement: 'viewport',
          forceAbsolute: true
        }
      }
    }
  },
  data () {
    return {
      visible: this.value,
      // poppperHover: false,
      popperJS: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.visible = val
        // 不需要与visible一起出发input 事件来实现双向绑定，只需要设置visible那边的input
        // this.$emit('input', val)
        if (val) {
          this.updatePopper()
          this.$emit('on-popper-show')
        }
      }
    },
    visible (val) {
      if (val) {
        this.updatePopper()
        this.$emit('on-popper-show')
      } else {
        this.destroyPopper()
        this.$emit('on-popper-hide')
      }
      this.$emit('input', val)
    }
  },
  methods: {
    createPopper () {
      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.placement)) {
        return
      }
      if (!this.visible) {
        return
      }
      this.$nextTick(() => {
        const options = this.options
        const popper = this.popper || this.$refs.popper
        let reference = this.reference || this.$refs.reference
        if (!popper || !reference) return
        if (this.popperJS && this.popperJS.hasOwnProperty('destroy')) {
          this.popperJS.destroy()
        }
        document.body.appendChild(popper)
        popper.one('mouseenter', () => {
          if (!this.trigger || this.trigger === 'hover') {
            this.visible = true
          }
        }, true)
        popper.one('mouseleave', () => {
          if (!this.trigger || this.trigger === 'hover') {
            this.visible = false
          }
        }, true)
        const isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1
        const boundariesElement = isIE10 === true ? 'body' : 'viewport'
        options.placement = this.placement
        options.modifiers = {
          preventOverflow: {
            boundariesElement: boundariesElement
          },
          computeStyle: {
            gpuAcceleration: false
          }
        }
        let vm = this
        this.popperJS = new Popper(reference, popper, options)
        this.popperJS.onCreate = function (data) {
          vm.resetTransformOrigin(data)
          vm.$nextTick(vm.updatePopper)
        }
      })
    },
    updatePopper () {
      this.popperJS ? this.popperJS.update() : this.createPopper()
    },
    doDestroy () {
      const popper = this.popper || this.$refs.popper
      if (this.popperJS && popper) {
        if (popper.parentNode) {
          popper.parentNode.removeChild(popper)
        } else {
          this.popperJS.popper.parentNode.removeChild(this.popperJS.popper)
        }
        this.popperJS.destroy()
        this.popperJS = null
      }
    },
    destroyPopper () {
      if (this.popperJS) {
        this.doDestroy()
        // this.resetTransformOrigin(this.popperJS)
      }
    },
    resetTransformOrigin (data) {
      if (!data.instance) {
        return
      }
      // 针对位置计算误差
      const refRight = data.instance.reference.getBoundingClientRect().right
      const popperLeft = data.instance.popper.getBoundingClientRect().right
      if (refRight - popperLeft > 1) { // 超过1px偏差
        this.popperJS && this.popperJS.scheduleUpdate()
      }
    }
  },
  beforeDestroy () {
    if (this.popperJS) {
      this.doDestroy()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/base/popper.js